import React, {useState} from "react";
import axios from 'axios';
import { Action, Store } from "@byhuz/huz-ui-state";
import ModalBox from "components/Alert/Modal.js";
import Spinner from "components/Alert/Spinner";
import useAuth from "components/Common/UseAuth";
import CardSACodes from "components/Cards/CardSACodes";
import CardSWIDS from "components/Cards/CardSwIDS";
import Paypal from "components/Common/Paypal";

// components
export default function VINDecoder() {
    const {checkSession,user}=useAuth();
    const [modalDetail, setModalDetail] = useState("");  
    const showModal = (title,desc) => {
      setModalDetail(<ModalBox title={title} desc={desc} show="true" callback={()=>{
          setModalDetail(<div></div>);  
          setLoading(false);        
      }}/>);
    }
        
    const countRef = React.useRef(0);
    const intervalVINIDRef = React.useRef(null);
    const [loading, setLoading] = useState(false);
    const [ vin, setVIN ] = React.useState("");    
    const [ sacodes, setSacodes ] = React.useState([]);
    const [ swids, setSwids ] = React.useState([]);
    const [ car_brand, setCar_brand ] = React.useState("");
    const [ car_model, setCar_model ] = React.useState("");
    const [ car_bodytype, setCar_bodytype ] = React.useState("");
    const [ car_production, setCar_production ] = React.useState("");
    const [ car_bodycolor, setCar_bodycolor ] = React.useState("");
    const [ car_interiorcolor, setCar_interiorcolor ] = React.useState("");
    const [ car_enginenumber, setCar_enginenumber ] = React.useState("");
    const [ car_transmissionnumber, setCar_transmissionnumber ] = React.useState("");  
    const [ suggestion, setSuggestion ] = React.useState([]);
    const [ car_image, setCar_image ] = React.useState("mb.png");
    
      
  
  // Generation Function
  const handleImageError = e => {
    e.stopPropagation();
    setCar_image("mb.png");
    console.log("image not found")
  }


  const getCodeFromServer = () => {
    const vinDecoderData = {
      vin: vin.toLocaleUpperCase(),
      sku: "vindecoder"
    }

    axios.post('vindecoder',vinDecoderData)
    .then(res=>{

      if (parseInt(res.data.code)===404) {       
        showModal("VIN Decoder",
            <>     
            <span>VIN Decoder Not Generated!</span>   
            </>  
        );
        setLoading(false);
        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;        
        return;
      }

      if (parseInt(res.data.code)===401) {       
        showModal("VIN Decoder",
            <>     
            <span>Try Again!</span>   
            </>  
        );
        setLoading(false);
        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;        
        return;
      }

      if (parseInt(res.data.code)===402) {       
        showModal("VIN Decoder",
            <>     
            <span>VIN Number is Incorrect!</span>   
            </>  
        );
        setLoading(false);
        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;        
        return;
      }

      if (parseInt(res.data.code)===400) {       
        showModal("VIN Decoder",
            <>     
            <span>Not Enough Credit, Please buy credits!</span>   
            </>  
        );
        setLoading(false);
        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;        
        return;
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===3 && res.data.payload.result.found===1) {              
        setLoading(false);

        setCar_bodycolor(res.data.payload.result.bodycolor);
        setCar_bodytype(res.data.payload.result.bodytype);
        setCar_brand(res.data.payload.result.brand);
        setCar_enginenumber(res.data.payload.result.engineno);
        setCar_interiorcolor(res.data.payload.result.interiorcolor);
        setCar_model(res.data.payload.result.model);
        setCar_production(res.data.payload.result.production);
        setCar_transmissionnumber(res.data.payload.result.transmissionno);
        try {
          setSacodes(JSON.parse(res.data.payload.result.sacodes));
          analyzeSACodes(JSON.parse(res.data.payload.result.sacodes));
        } catch(e) {
          console.log(e);
        }
        try {
          setSwids(JSON.parse(res.data.payload.result.swids));          
        } catch(e) {
          console.log(e);
        }

        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;
        checkSession();
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===3 && res.data.payload.result.found===0) {                     
        setLoading(false);
        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;
        checkSession();
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===1 && res.data.payload.result.found===2) {                     
        setLoading(false);
        clearInterval(intervalVINIDRef.current);
        intervalVINIDRef.current = null;
        checkSession();
        showModal("VIN Decoder",
            <>     
            <span>Try Again!</span>   
            </>  
        );
      }


      if (parseInt(res.data.code)===300 || parseInt(res.data.code)===301) {      
        setLoading(true);
      }

    })
    .catch(err=>{
      console.log(err);
      Store.dispatch(Action.update("loggedIn", false));
      Store.dispatch(Action.update("user"));
      return;
    });      

    if (countRef.current>=50) {
      clearInterval(intervalVINIDRef.current);
      intervalVINIDRef.current = null;
      countRef.current = 0;
      setLoading(false);
      showModal("VIN Decoder",
        <>     
        <span>VIN Decoder Not Generated!, Try Again</span>   
        </>  
      );
    }
        
    countRef.current++;         
  }

  const analyzeSACodes = (sacodes) => {
    setSuggestion("");
    
    setCar_image(vin.substring(3,6)+".jpg");

    switch(vin.substring(0,6)) {
        case "WDF470":
        case "WDD253":
        case "W1K205":
        case "W1N463":
            setSuggestion(prev => [...prev, (<><span>Options that can be enabled include <b>IC213 AMG Menus</b>. </span></>)]);  
        break;
        case "WDD222":
            setSuggestion(prev => [...prev, (<><span>Options that can be enabled include <b>IC222 AMG Menus</b> </span></>)]);  
          break;
        case "WDD117":
        case "WDD176":
            setSuggestion(prev => [...prev, (<><span>Options that can be enabled include <b>IC172 AMG Menus</b> </span></>)]);  
          break;
        case "WDD257":
        case "WDD213":
            setSuggestion(prev => [...prev, (<><span>Options that can be enabled include <b>IC213 AMG Menus</b>. </span></>)]);  
          break;
          case "WDD207":
          case "WDD212":
          case "WDD204":
              setSuggestion(prev => [...prev, (<><span>Options that can be enabled include <b>IC204 AMG Menus</b> </span></>)]);  
            break;
          default:
            //setSuggestion(prev => [...prev, (<><span>You can enable <b>AMG menu</b>. </span></>)]);  
          break
    }

    const nextItem = sacodes.map((item,index) => {      
      switch(item["codeNumber"]) {
        case "357":
            setSuggestion(prev => [...prev, (<><span>You can order <b>{item[2]}</b> for your Head Unit. </span></>)]);  
          break;        
        case "464":
            setSuggestion(prev => [...prev, (<><span>You can enable <b>AMG Menu</b> for your <b>{item[2]}</b>. </span></>)]);  
          break;        
        case "522":
          setSuggestion(prev => [...prev, (<><span>The vehicle is equipped with <b>{item[2]}</b>, which utilizes an SD Card for Map Data. It is also possible to enable <b>AMG Menu</b>.</span></>)]);  
          break;
        case "506":            
          setSuggestion(prev => [...prev, (<><span>The vehicle is equipped with <b>{item[2]}</b>, which utilizes an SD Card for Map Data. </span></>)]);  
          setSuggestion(prev => [...prev, (<><span>Options that can be enabled <b>Apple CarPlay/Android Auto</b>, AMG Comand Logos and Graphics and more.. </span></>)]);  
          break;
        case "EU4":
        case "531":            
          setSuggestion(prev => [...prev, (<><span>The vehicle is equipped with <b>{item[2]}</b>, which allows for Navigation updates. You can generate a map code by visiting <a href="/admin/mapcodes"><b>MAP CODES</b></a>. </span></>)]);  
          setSuggestion(prev => [...prev, (<><span>Options that can be enabled <b>Apple CarPlay/Android Auto</b>, AMG Comand Logos and Graphics and more.. </span></>)]);  
        break;
        case "527":            
          setSuggestion(prev => [...prev, (<><span>The vehicle is equipped with <b>{item[2]}</b>, which allows for Navigation updates. You can generate a map code by visiting <a href="/admin/mapcodes"><b>MAP CODES</b></a>. </span></>)]);  
          break;
        default:          
          break;
      }
      return item;
    });

    setSuggestion(prev => [...prev, (<br></br>)]);  
    
  }

  const handleSubmitVINDecoder = (e) => {
    e.preventDefault();

    if (vin==="" || vin==="" || vin.length!==17) {
        showModal("VIN Decoder",
            <>     
            <span>Check VIN Number</span>   
            </>  
        );
        return;
    }

    setLoading(true);
    setSacodes([]);
    setSwids([]);

    intervalVINIDRef.current = setInterval(getCodeFromServer,3000);    
    getCodeFromServer();
  }

  const PaymentSuccess = () => {    
    setLoading(false);
    checkSession();
    showModal("MBLink Payment Method",
        <>     
          <span>Thank you for purchasing...</span>   
        </>  
    );
  }

  const PaymentError = (err) => {
    setLoading(false);
    showModal("MBLink Payment Method",
        <>     
          <span>Payment could not be received. Please try again!</span>   
        </>  
    );
  }

  const PaymentStart = () => {
    setLoading(true);
  }  

  const doPayment = (price,sku) => {
    showModal("MBLink Payment Method",
        <>     
          <Paypal sku={sku} onSuccess={PaymentSuccess} onError={PaymentError} onStartTransaction={PaymentStart}></Paypal>   
        </>  
    );
  }

  const getPrice = (sku) => {
    let price = 0;
    user.availabletokens.forEach(skutypes => {
        if (skutypes.sku===sku) {  
          price=skutypes.price;
          return;          
        }
    });
    return price;
  }

  React.useEffect(()=>{    
  },[]);

  return (
    <>
    {loading?<Spinner show={loading} />:null}
    {modalDetail!==""?modalDetail:null}
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">

            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-gray-800 text-xl font-bold">VIN DECODER</h6>
                        <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-sm px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                          type="button"
                          onClick={(e)=>doPayment(getPrice("vindecoder"),"vindecoder")}
                          >
                            BUY {getPrice("vindecoder")} EUR 
                        </button>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                    <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">              
                    </h6>
                    <div className="flex flex-wrap">                        

                        <div className="w-full lg:w-6/12 px-4">                           
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    VIN Number (17 chars)
                                </label>
                                <div className="mb-3 pt-0">
                                    <input type="text" 
                                        placeholder="WDD21300001A000000" 
                                        onChange={e=> setVIN(e.target.value.toLocaleUpperCase())}                                        
                                        className="uppercase px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-1/3"/>
                                </div>

                            </div>

                            <div className="relative w-full mb-3">
                                <button
                                className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                                type="button" onClick={handleSubmitVINDecoder}
                                >
                                VIN Decode
                                </button>
                            </div>
                        </div>  

                        <div className="w-full lg:w-6/12 px-4">                           
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Car Information
                                </label>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-8/12">
                                        <span>Note: We would like to inform our customers that we cannot guarantee the accuracy of the car information provided. </span><br></br><br></br>
                                        {suggestion!=null && suggestion}
                                        <span><br></br>To activate these options please visit our <a href="/admin/download"><b>DOWNLOAD</b></a> page and make use of <b>MBLink Tools</b>.</span>
                                    </div>
                                    <div className="w-full lg:w-4/12">
                                        <img
                                          alt= {`${vin}`}
                                          width={230}                                          
                                          src={`/static/media/mb/${car_image}`}
                                          onError={handleImageError}                                                                                    
                                          className="shadow-xl h-auto align-middle rounded border border-solid border-blueGray-200 mr-auto ml-auto"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>  

                        <div className="w-full lg:w-6/12 px-4">                           
                            <div className="relative w-full mb-3">
                              <div
                                className={
                                  "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blue-900 text-white" 
                                }
                              >
                                  <div className="rounded-t mb-0 px-4 py-3 border-0">
                                    <div className="flex flex-wrap items-center">
                                      <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                                        <h3
                                          className={
                                            "font-semibold text-lg text-white" 
                                          }
                                        >
                                          General
                                        </h3>
                                      </div>
                                    </div>
                                  </div> 
                                  <div className="container px-4 mx-auto">                            
                                    <div className="w-full bg-blue-800 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Brand:</b></div>
                                        <div className="w-full flex-1">{car_brand}</div>                                    
                                      </div>
                                    </div>
                                    <div className="w-full bg-blue-900 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Model:</b></div>
                                        <div className="w-full flex-1">{car_model}</div>                                    
                                      </div>
                                    </div>
                                    <div className="w-full bg-blue-800 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Body Type:</b></div>
                                        <div className="w-full flex-1">{car_bodytype}</div>                                    
                                      </div>
                                    </div>
                                    <div className="w-full bg-blue-900 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Production:</b></div>
                                        <div className="w-full flex-1">{car_production}</div>                                    
                                      </div>
                                    </div>
                                  </div>
                                </div>

                            </div>
                        </div>  

                        <div className="w-full lg:w-6/12 px-4">                           
                            <div className="relative w-full mb-3">
                              <div
                                  className={
                                    "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blue-900 text-white" 
                                  }
                                >
                                  <div className="rounded-t mb-0 px-4 py-3 border-0">
                                    <div className="flex flex-wrap items-center">
                                      <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                                        <h3
                                          className={
                                            "font-semibold text-lg text-white" 
                                          }
                                        >
                                          Color & Engine
                                        </h3>
                                      </div>
                                    </div>
                                  </div>   

                                  <div className="container px-4 mx-auto">                            
                                    <div className="w-full bg-blue-800 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Body Color:</b></div>
                                        <div className="w-full flex-1">{car_bodycolor}</div>                                    
                                      </div>
                                    </div>
                                    <div className="w-full bg-blue-900 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Interior Color:</b></div>
                                        <div className="w-full flex-1">{car_interiorcolor}</div>                                    
                                      </div>
                                    </div>
                                    <div className="w-full bg-blue-800 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Engine Number:</b></div>
                                        <div className="w-full flex-1">{car_enginenumber}</div>                                    
                                      </div>
                                    </div>
                                    <div className="w-full bg-blue-900 text-blue-300 border-blue-700 px-3 py-3">
                                      <div className="flex flex-wrap">
                                        <div className="w-full flex-1"><b>Transmission Number:</b></div>
                                        <div className="w-full flex-1">{car_transmissionnumber}</div>                                    
                                      </div>
                                    </div>
                                  </div>                          
                                </div>
                            </div>
                        </div>  

                        <div className="w-full px-4">
                            <div className="relative w-full mb-3">
                              <CardSACodes color="dark" token={sacodes}/>
                            </div>
                        </div>  
                        <div className="w-full mb-12 px-4">
                            <div className="relative w-full mb-3">
                              <CardSWIDS color="dark" token={swids}/>
                            </div>
                        </div>  

                    </div>

                    <hr className="mt-6 border-b-1 border-gray-400" />

                </form>
                </div>
            </div>

        </div>
      </div>
    </>
  );
}
